import { Component } from '@angular/core';

@Component({
  selector: 'nuc-redirection',
  imports: [],
  templateUrl: './redirection.component.html',
  styleUrl: './redirection.component.scss'
})
export class RedirectionComponent {

}
